
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import alarmList from './alarmList'
import newSubDeviceDetail from './NewSubDeviceDetail'
import newSubDeviceChild from './NewSubDeviceChild'
import childHealth from './childHealth.vue'
import newSubDeviceSet from './NewSubDeviceSet'
import historyList from './historyList'
import voiceRecordList from './voiceRecordList'
import deviceMember from './DeviceMember'
import {deldevice, sendcommand, updatedevice} from '../../api/device'
import {queryDeviceSimCard} from '@/api/simcard'
import { isServicePlanAllowed } from '@/api/servicePlan'

export default {
name: 'NewDeviceDetail',
directives: {TransferDom},
components: {alarmList, newSubDeviceDetail, newSubDeviceChild, childHealth, newSubDeviceSet, historyList, voiceRecordList, deviceMember},
data () {
return {
deviceImgArr: [],

device: '',
navs: [
{id: 1, name: '接入设备', dTypes: [400, 700, 701, 800]},
{id: 2, name: '设备详情', dTypes: [301, 401, 402, 404, 504, 506, 507, 508, 509, 510, 511, 537, 538, 543, 545, 700, 701, 751, 752, 753, 780, 408, 902, 904, 905, 906, 920]},
{id: 3, name: '健康数据', dTypes: [310, 311, 312, 330, 332]},
{id: 4, name: '设备设置', dTypes: [901, 310, 311, 312, 330, 332]},
{id: 5, name: '历史记录', dTypes: [301, 401, 402, 404, 504, 506, 507, 508, 509, 510, 511, 537, 538, 543, 545, 751, 752, 753, 780, 408, 904, 905, 906, 920]},
{id: 6, name: '语音记录', dTypes: [901]},
{id: 7, name: '设备成员', dTypes: []}
],
showNavs: [],
selectNavId: '',


unHandleAlarmShow: false, // 未处理弹窗
editDeviceShow: false, // 编辑主设备
editDeviceObj: {
name: '',
address: ''
},
delDeviceShow: false, // 解绑主设备
callHintShow: false 
}
},
created () {

Date.prototype.format = this.validate.format
this.golobleObject.changeDevicePage = this.mqttChangeDevice
this.golobleObject.getMqttDoor = this.mqttChangeDoorStatus
this.getStartData()
},
mounted () {
document.getElementsByTagName('title')[0].innerText = '设备详情'
},
beforeDestroy () {
document.getElementsByTagName('title')[0].innerText = '智慧安防'
},
methods: {
mqttChangeDevice (obj) {
if (obj.type === 'lockdoor') { // 401开关门状态、开关锁状态
if (parseFloat(obj.alarm.did) === this.device.id) {
if (obj.alarm.alarmtype === 'wifilock_open') {
this.$toast('开锁成功')
this.device.mainConfig.lockStatus.value = 0
} else if (obj.alarm.alarmtype === 'wifilock_close') {

this.device.mainConfig.lockStatus.value = 1
} else if (obj.alarm.alarmtype === 'lockopendoor') {
this.device.mainConfig.doorStatus.value = 1
} else if (obj.alarm.alarmtype === 'lockclosedoor') {
this.device.mainConfig.isOpenDoor.value = 0
}
}
} else if (obj.type === 'deviceStatus') {
if (obj.alarm.imei === this.device.deviceid) {
if (obj.alarm.activestate) {
this.device.mainConfig.activeState.value = obj.alarm.activestate
}
if (obj.alarm.armstatus) {
this.device.mainConfig.armStatus.value = obj.alarm.armstatus === 'on' ? 1 : 0
}
if (obj.alarm.devicestatus) {
if (obj.alarm.devicestatus === 'door-close') {
this.device.mainConfig.doorStatus.value = 0
} else if (obj.alarm.devicestatus === 'door-open') {
this.device.mainConfig.doorStatus.value = 1
}
}
if (obj.alarm.temperature) {
this.device.mainConfig.temperature.value = obj.alarm.temperature
}
}
}
},
mqttChangeDoorStatus (obj) {
if (parseFloat(obj.did) === this.device.id) {
if (obj.alarmtype === '906info') {
let passThrough = obj.passthrough
const bytes = (passThrough.split('PSAA')[1]).match(/.{1,2}/g).map(byte => parseInt(byte, 16))
if (bytes[0] !== 0x04) {
if (bytes.length >= 3) {
let batteryStatus = bytes[1] & 0x0F
let batteryVol = bytes[2] * 0.2
let batteryPercent = 0
if (batteryVol > 21) {
batteryPercent = 100
} else if (batteryVol < 17.5) {
batteryPercent = 0
} else {
batteryPercent = Math.round(((bytes[2] * 0.2) - 17.5) / (21 - 17.5) * 100)
}
this.device.mainConfig.batteryStatus.value = batteryStatus
this.device.mainConfig.batteryVol.value = batteryVol.toFixed(1) + 'V'
this.device.mainConfig.batteryPercent.value = batteryPercent + '%'
this.device.mainConfig.outputVol.value = (bytes[3] * 0.2).toFixed(1) + 'V'
}
}
} else {
this.device.unhandlealarm += 1
if (obj.alarmtype === 'doorclose' || obj.alarmtype === 'door-close') {
this.device.mainConfig.doorStatus.value = 0
} else if (obj.alarmtype === 'dooropen' || obj.alarmtype === 'door-open') {
this.device.mainConfig.doorStatus.value = 1
} else if (obj.alarmtype === 'batterylowvoltage') {
this.device.mainConfig.batteryStatus.value = 3
} else if (obj.alarmtype === 'switchbattery') {
this.device.mainConfig.batteryStatus.value = 2
} else if (obj.alarmtype === 'switchexternalpower') {
this.device.mainConfig.batteryStatus.value = 1
}
}
this.$refs.subDeviceDetail.mqttChange(this.device)
}
},

getStartData () {
this.deviceImgArr = this.common.getDeviceImg()
this.device = this.$store.getters.get_child_obj
this.showNavs = this.navs.filter(r => r.dTypes.length !== 0 ? r.dTypes.indexOf(this.device.dtype) >= 0 : true)
this.selectNavId = this.showNavs.length !== 0 ? this.showNavs[0].id : ''
console.log(this.device, this.showNavs)

if ([504, 508].indexOf(this.device.dtype) !== -1 && this.device.isonline === 0 &&
this.device.last_online >= '2025-11-30 00:00:00' && this.device.last_online <= '2025-12-1 23:59:59') {
this.$dialog.alert({
type: 'warning',
title: '提示',
message: '运营商流量卡已过期，请添加客服微信：sdankang888更换流量卡。'
})
}

if (this.device.id && (!this.device.simcard || !this.device.simcard.validdate)) {
queryDeviceSimCard({ did: this.device.id, iccid: this.device.iccid || '' }).then(res => {
if (res && res.data && res.data.simcard) {
this.$set(this.device, 'simcard', res.data.simcard)
}
}).catch(err => {
console.log('queryDeviceSimCard err', err)
})
}
},

getDeviceImageUrl (dType) {
let img = this.deviceImgArr[this.deviceImgArr.length - 1].imgUrl
let deviceImg = this.deviceImgArr.find(r => r.dtype === dType)
if (deviceImg) {
img = deviceImg.imgUrl
}
return img
},

getDeviceVoltage (item) {
let result = '--'
if (item.mainConfig.batteryVol) {
let batteryVol = item.mainConfig.batteryVol.value
if (item.dtype === 402 || item.dtype === 404 || item.dtype === 505) {
result = Math.round((batteryVol / 1000) * 10) / 10
} else if (item.dtype === 503 || item.dtype === 504 || item.dtype === 506 || item.dtype === 507 ||
item.dtype === 508 || item.dtype === 509 || item.dtype === 510 || item.dtype === 511 ||
item.dtype === 904 || item.dtype === 905) {
result = batteryVol > 100 ? Math.round((batteryVol / 100) * 10) / 10 : Math.round(batteryVol * 10) / 10
} else {
result = batteryVol
}
}
return result === '--' || (result + '').indexOf('V') !== -1 ? result : result + 'V'
},

getDeviceBattery (item) {
let result = '--'
if (item.dtype === 901) {
result = item.battery
} else {
if (item.mainConfig.battery) {
result = item.mainConfig.battery.value
}
}
return result === '--' || (result + '').indexOf('%') !== -1 ? result : result + '%'
},

getDeviceTamperStatus (item) {
let result = '--'
if (item.mainConfig.tamperStatus) {
if (item.mainConfig.tamperStatus.value === 0) {
result = '压下'
} else if (item.mainConfig.tamperStatus.value === 1) {
result = '打开'
} else {
result = item.mainConfig.tamperStatus.value
}
}
return result
},

getDevicePressValue (item) {
let result = '--'
if (item.mainConfig.pressValue) {
result = item.mainConfig.pressValue.value
switch (item.mainConfig.pressUnits.value) {
case 0:
result += ' mPa'
break
case 1:
result += ' Pa'
break
case 2:
result += ' hPa'
break
case 3:
result += ' kPa'
break
}
}
return result
},

getDeviceTemperature (item) {
let result = item.mainConfig.temperature ? item.mainConfig.temperature.value : '--'
return result === '--' || (result + '').indexOf('℃') !== -1 ? result : result + '℃'
},

getDeviceHumidity (item) {
let result = item.mainConfig.humidity ? item.mainConfig.humidity.value : '--'
return result === '--' || (result + '').indexOf('%') !== -1 ? result : result + '%'
},

getSignal (item) {
let result = '--'
if (item.mainConfig.signal) {
let signal = item.mainConfig.signal.value
if (signal === 0) {
result = '极弱'
} else if (signal === 1) {
result = '弱'
} else if (signal === 2) {
result = '一般'
} else if (signal === 3) {
result = '强'
} else if (signal === 4) {
result = '极好'
}
}
return result
},


isShowSelfPhone (type) {

return [700, 200, 800, 901, 902].indexOf(type) >= 0
},
isShowServicePlan (device) {
if (!isServicePlanAllowed()) return false
if (!device) return false
if (this.common && this.common.isNbOrNon4G(device.dtype)) {
return false
}
let status = ''
if (device.service_plan && device.service_plan.expire_status) {
status = device.service_plan.expire_status
} else if (device.simcard && device.simcard.expire_status) {
status = device.simcard.expire_status
}

return status === 'expiring' || status === 'expired'
},
getServiceValidDate (device) {
if (device.service_plan && device.service_plan.service_expire_tm) {
return device.service_plan.service_expire_tm
}
if (device.simcard && device.simcard.validdate) {
return device.simcard.validdate
}
return '待激活'
},
getServiceExpireBadge (device) {
let status = ''
let days = 0
if (device.service_plan && device.service_plan.expire_status) {
status = device.service_plan.expire_status
days = device.service_plan.days_left
} else if (device.simcard && device.simcard.expire_status) {
status = device.simcard.expire_status
days = device.simcard.days_left
}
if (status === 'expired') {
return { text: '已到期', cls: 'badge-expired' }
} else if (status === 'expiring') {
return { text: `剩${days}天到期`, cls: 'badge-expiring' }
}
return null
},
isShowSimCard (device) {
return this.isShowServicePlan(device)
},
getSimCardNum (device) {
if (device.simcard && device.simcard.phonenum) {
return device.simcard.phonenum
}
if (device.simcard && device.simcard.iccid) {
return device.simcard.iccid
}
return device.iccid || device.devicephone || ''
},
getSimValidDate (device) {
return this.getServiceValidDate(device)
},
getSimExpireBadge (device) {
return this.getServiceExpireBadge(device)
},
handleRechargeClick () {
this.$toast('服务续费功能即将开放，敬请期待！')
},
isShowStatus (type) {
return this.isHaveDefence(type) || this.isHaveDoor(type) || this.isHaveActive(type) || this.isShowVoltage(type) ||
this.isShowBattery(type) || this.isShowTamper(type) || this.isShowPress(type) ||
this.isShowTemperature(type) || this.isShowHumidity(type) || this.isShowSignal(type)
},
isHaveDefence (type) {
return [543].indexOf(type) >= 0
},
isHaveLock (type) {
return [400, 401].indexOf(type) >= 0
},
isHaveDoor (type) {

return [402, 404, 504, 508, 509, 538, 543].indexOf(type) >= 0
},
isHaveActive (type) {

return [752, 780, 408].indexOf(type) >= 0
},
isShowVoltage (type) {

return [].indexOf(type) >= 0
},
isShowBattery (type) {

return [].indexOf(type) >= 0
},
isShowTamper (type) {

return [505].indexOf(type) >= 0
},
isShowPress (type) {

return [503].indexOf(type) >= 0
},
isShowTemperature (type) {

return [].indexOf(type) >= 0
},
isShowHumidity (type) {

return [].indexOf(type) >= 0
},
isShowSignal (type) {

return [753].indexOf(type) >= 0
},
isNoOnline (type) {
return [402, 800].indexOf(type) >= 0
},

changeLock () {
if (this.device.isonline !== 1) {
return
}
let data = {
did: this.device.id,
cmd: 'open'
}
sendcommand(data).then(res => {
this.$toast('发送成功指令')

}).catch(() => {})
},
openAlarmList () {
if (this.device.unhandlealarm > 0) {
this.unHandleAlarmShow = true
}
},
getFatherChange (num) {
let val = this.device.unhandlealarm - num
if (val > 0) {
this.device.unhandlealarm = val
} else {
this.device.unhandlealarm = 0
}
this.$store.commit('set_child_obj', this.device)
},
openEditDevice () {

if (this.device.phonedevicerole !== 'normal' && this.device.phonedevicerole !== '' && this.device.phonedevicerole !== 'familyshare') {
this.editDeviceObj.name = this.device.name
this.editDeviceObj.address = this.device.address
this.editDeviceShow = true
}
},
openNBLock () {
let vm = this

this.$vux.confirm.show({
title: '授权确认',
content: '请确保安全的情况下执行本次操作，要执行授权吗？',
onConfirm () {
let data = {
did: parseInt(this.device.id),
cmd: 'openlock'
}
sendcommand(data).then(res => {
vm.$toast('授权成功，2分钟以内有效。')
}).catch(() => {})
}
})
},
openSelectNav (item) {
this.selectNavId = item.id
},

editDeviceClick () {
let data = {
did: parseInt(this.device.id),
name: this.editDeviceObj.name,
devicephone: this.device.devicephone,
address: this.editDeviceObj.address
}
updatedevice(data).then(res => {
if (res.code === 200) {
this.$toast('成功')
this.device.name = this.editDeviceObj.name
this.device.address = this.editDeviceObj.address
} else {
this.$toast(res.msg)
}
this.editDeviceShow = false
}).catch(() => {
this.editDeviceShow = false
this.$toast('失败')
})
},
delDeviceClick (id) {
let data = {
dids: [parseInt(id)]
}
deldevice(data).then(res => {
if (res.code === 200) {
this.delDeviceShow = false
this.$router.push('/Device')
} else if (res.code === 50004) {
this.$toast('此账号解绑需返还赠送语音和短信，余额不足，设备解绑失败.')
} else {
this.$toast('失败')
}
}).catch(err => {
if (err.response && err.response.data && err.response.data.code === 50004) {
this.$toast('此账号解绑需返还赠送语音和短信，余额不足，设备解绑失败.')
} else {
this.$toast('失败')
}
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/device/NewDeviceDetail.vue